import {Typography, SxProps, Theme} from "@mui/material";

import {designTokens} from "~/ui";
import {bmPxToRem} from "~/ui/designTokens";

export interface BmCardTitleProps {
  className?: string;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

export const BmCardTitle: React.FC<BmCardTitleProps> = ({className, sx, children}) => {
  return (
    <Typography
      variant="h3"
      className={className}
      sx={{
        mb: 0,
        fontSize: designTokens.fontSize.mdl,
        fontWeight: designTokens.fontWeight.bold,
        lineHeight: bmPxToRem("24px"),
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
